module.exports = __webpack_public_path__ + "img/2021_NMI.8e3adb97.jpg";